import { CalloutBox } from 'components/Docs/CalloutBox';
import InstallWebPackageManagers from "../../../../contents/docs/integrate/_snippets/install-web-package-managers.mdx";
import * as React from 'react';
export default {
  CalloutBox,
  InstallWebPackageManagers,
  React
};